import React from 'react';
import { Grid } from '@material-ui/core';

import Card from './Card';
import InfluencerForm from './InfluencerForm';
import SignUpForm from './SignUpForm';

const containerStyle = { minHeight: 'auto', maxWidth: 600, margin: '0 auto', padding: '0 15px' };

const TwoCards = ({ isDialog = false, openForm, setOpenForm, contentOne, contentTwo }) => (
  <div style={!isDialog ? { paddingTop: 50 } : {}}>
    <h2 style={{ textAlign: 'center', margin: '35px 0 30px', fontSize: 24 }}>Which are you?</h2>

    <Grid container justifyContent="center" style={containerStyle}>
      <Grid item xs={6}>
        <Card
          title="Individual"
          content={contentOne}
          firstChild
          buttonText="Select"
          handleClick={() => setOpenForm({ influencer: true, advertiser: false })}
          selected={openForm.influencer}
          showButton={openForm.influencer || openForm.advertiser}
        />
      </Grid>

      <Grid item xs={6}>
        <Card
          title="Company"
          content={contentTwo}
          buttonText="Select"
          handleClick={() => setOpenForm({ advertiser: true, influencer: false })}
          selected={openForm.advertiser}
          showButton={openForm.influencer || openForm.advertiser}
        />
      </Grid>
    </Grid>

    {openForm.influencer && <InfluencerForm isDialog={isDialog} primaryInterest="buy" />}
    {openForm.advertiser && <SignUpForm isDialog={isDialog} />}
  </div>
);

export default TwoCards;
